import './logo.css'

type LogoSize = 'sm' | 'md' | 'lg' | 'xl'

const sizes = {
  sm: { mark: 24, word: 14, sub: 8, gap: 8, letter: 1.2 },
  md: { mark: 36, word: 20, sub: 9, gap: 10, letter: 1.6 },
  lg: { mark: 54, word: 30, sub: 10, gap: 14, letter: 2.0 },
  xl: { mark: 80, word: 50, sub: 11, gap: 18, letter: 3.0 },
}

export function CFMark(props: { size?: number }) {
  const sz = () => props.size ?? 40
  const gid = () => `cfg-${sz()}`
  return (
    <span class="cf-mark" style={{ '--cf-mark-size': `${sz()}px` }}>
      <svg
        viewBox="0 0 48 48"
        width={sz() * 0.58}
        height={sz() * 0.58}
        fill="none"
        aria-hidden="true"
      >
        <defs>
          <linearGradient
            id={gid()}
            x1="0"
            y1="0"
            x2="48"
            y2="48"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0%" stop-color="#FF3CAC" />
            <stop offset="100%" stop-color="#00E5FF" />
          </linearGradient>
        </defs>
        <path
          d="M18 14 a10 10 0 1 0 0 20"
          stroke={`url(#${gid()})`}
          stroke-width="4.5"
          stroke-linecap="round"
        />
        <path
          d="M30 14 v20 M30 14 h10 M30 24 h8"
          stroke={`url(#${gid()})`}
          stroke-width="4.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </span>
  )
}

export function CFLogo(props: {
  size?: LogoSize
  showSub?: boolean
  ariaLabel?: string
}) {
  const s = () => sizes[props.size ?? 'md']
  return (
    <span
      class={`cf-logo cf-logo-${props.size ?? 'md'}`}
      aria-label={props.ariaLabel ?? 'CosplayFans'}
      role="img"
      style={{ gap: `${s().gap}px` }}
    >
      <CFMark size={s().mark} />
      <span class="cf-word-block">
        <span
          class="cf-word"
          style={{ 'font-size': `${s().word}px`, 'letter-spacing': `${s().letter}px` }}
        >
          COSPLAYFANS
        </span>
        {props.showSub && (
          <span
            class="cf-sub"
            style={{
              'font-size': `${s().sub}px`,
              'letter-spacing': `${s().letter * 2.5}px`,
            }}
          >
            AI &middot; COSPLAY &middot; CREATORS
          </span>
        )}
      </span>
    </span>
  )
}
